import {ApiResponse} from "@/services/responses/ApiResponse";
import {EventBus} from "@/pitprojekt/event-bus";

export class Success extends ApiResponse {

    constructor(message: string, status: number = 200) {
        super(message, status);
    }

    showSnackbar() {
        if (this.message) EventBus.$emit('showSnackbarEvent', this.message, 'success');
    }

    public static showSnackbar(message: string): void {
        const successResponse = new Success(message);
        successResponse.showSnackbar();
    }
}

